import * as yup from 'yup'

// layouts情况下 比较特殊，保存的时候数据是个ref对象
export default function (opts) {
  const { required, multiple, layouts, showLayouts } = opts
  // 不规定类型
  let schema = yup.object()

  if (!layouts && !showLayouts) {
    schema = multiple ? yup.array().nullable() : yup.string().nullable()
  }
  if (required) {
    schema = schema.required('这是一个必填项')
  }

  if (required && multiple) {
    schema = schema.min(1, '这是一个必填项')
  }

  return schema
}
